/*
 * Gravur-Studio
 *
 * Reusable storefront workspace for products that offer an "Eigenes Motiv"
 * variant. Product-specific settings stay in the small Liquid bootstrap,
 * while the interaction and order properties live here.
 */
(function () {
  'use strict';

  if (window.__gravurStudio) {
    window.__gravurStudio.sync();
    return;
  }

  var configuration = {
    product: (window.__gravurStudioProductConfig && window.__gravurStudioProductConfig.product) || 'TRINI',
    customerOrderingEnabled: Boolean(window.__gravurStudioProductConfig && window.__gravurStudioProductConfig.customerOrderingEnabled === true),
    reviewOrderEnabled: Boolean(window.__gravurStudioProductConfig && window.__gravurStudioProductConfig.reviewOrderEnabled === true),
    splitCartPreviewEnabled: Boolean(window.__gravurStudioProductConfig && window.__gravurStudioProductConfig.splitCartPreviewEnabled === true),
    splitCartFeeAvailable: Boolean(window.__gravurStudioProductConfig && window.__gravurStudioProductConfig.splitCartFeeAvailable === true),
    variants: (window.__gravurStudioProductConfig && window.__gravurStudioProductConfig.variants) || [],
    customMotivValue: 'Eigenes Motiv',
    defaultFont: 'Galada',
    fontAssets: (window.__gravurStudioProductConfig && window.__gravurStudioProductConfig.fontAssets) || {},
    textEngineUrl: (window.__gravurStudioProductConfig && window.__gravurStudioProductConfig.textEngineUrl) || '',
    physicalArea: (window.__gravurStudioProductConfig && window.__gravurStudioProductConfig.physicalArea) || null,
    colorValues: {
      Rot: '#d92525',
      Weiß: '#c8c7c1',
      Schwarz: '#262626',
      Hellblau: '#4a9fd4',
      Gelb: '#d8b300',
      Grün: '#84bd28',
    },
    lidImages: (window.__gravurStudioProductConfig && window.__gravurStudioProductConfig.lidImages) || {},
    metalTexture: (window.__gravurStudioProductConfig && window.__gravurStudioProductConfig.metalTexture) || '',
    fonts: [
      { family: 'Eczar', label: 'Eczar', category: 'Serifen', fallback: 'serif' },
      { family: 'Faculty Glyphic', label: 'Faculty Glyphic', category: 'Serifen', fallback: 'serif' },
      { family: 'Marko One', label: 'Marko One', category: 'Serifen', fallback: 'serif' },
      { family: 'Alata', label: 'Alata', category: 'Serifenlos', fallback: 'sans-serif' },
      { family: 'Amaranth', label: 'Amaranth', category: 'Serifenlos', fallback: 'sans-serif' },
      { family: 'Strait', label: 'Strait', category: 'Serifenlos', fallback: 'sans-serif' },
      { family: 'Urbanist', label: 'Urbanist', category: 'Serifenlos', fallback: 'sans-serif' },
      { family: 'Alex Brush', label: 'Alex Brush', category: 'Lettering & Handschrift', fallback: 'cursive' },
      { family: 'Galada', label: 'Galada', category: 'Lettering & Handschrift', fallback: 'cursive' },
      { family: 'Grand Hotel', label: 'Grand Hotel', category: 'Lettering & Handschrift', fallback: 'cursive' },
      { family: 'Kaushan Script', label: 'Kaushan Script', category: 'Lettering & Handschrift', fallback: 'cursive' },
      { family: 'Leckerli One', label: 'Leckerli One', category: 'Lettering & Handschrift', fallback: 'cursive' },
      { family: 'Merienda', label: 'Merienda', category: 'Lettering & Handschrift', fallback: 'cursive' },
      { family: 'Norican', label: 'Norican', category: 'Lettering & Handschrift', fallback: 'cursive' },
      { family: 'Oleo Script', label: 'Oleo Script', category: 'Lettering & Handschrift', fallback: 'cursive' },
      { family: 'Oleo Script Swash Caps', label: 'Oleo Script Swash Caps', category: 'Lettering & Handschrift', fallback: 'cursive' },
      { family: 'Pacifico', label: 'Pacifico', category: 'Lettering & Handschrift', fallback: 'cursive' },
      { family: 'Sofia', label: 'Sofia', category: 'Lettering & Handschrift', fallback: 'cursive' },
      { family: 'Yesteryear', label: 'Yesteryear', category: 'Lettering & Handschrift', fallback: 'cursive' },
      { family: 'Agbalumo', label: 'Agbalumo', category: 'Schmuckschrift & Display', fallback: 'serif' },
      { family: 'Aladin', label: 'Aladin', category: 'Schmuckschrift & Display', fallback: 'cursive' },
      { family: 'Bahianita', label: 'Bahianita', category: 'Schmuckschrift & Display', fallback: 'sans-serif' },
      { family: 'Bangers', label: 'Bangers', category: 'Schmuckschrift & Display', fallback: 'sans-serif' },
      { family: 'Betania Patmos In GDL', label: 'Betania Patmos In GDL', category: 'Schmuckschrift & Display', fallback: 'cursive' },
      { family: 'Braah One', label: 'Braah One', category: 'Schmuckschrift & Display', fallback: 'sans-serif' },
      { family: 'Bungee', label: 'Bungee', category: 'Schmuckschrift & Display', fallback: 'sans-serif' },
      { family: 'Caacupe One', label: 'Caacupe One', category: 'Schmuckschrift & Display', fallback: 'serif' },
      { family: 'Karantina', label: 'Karantina', category: 'Schmuckschrift & Display', fallback: 'sans-serif' },
      { family: 'Lemon', label: 'Lemon', category: 'Schmuckschrift & Display', fallback: 'serif' },
      { family: 'Lobster', label: 'Lobster', category: 'Schmuckschrift & Display', fallback: 'cursive' },
      { family: 'Pattaya', label: 'Pattaya', category: 'Schmuckschrift & Display', fallback: 'cursive' },
      { family: 'Poetsen One', label: 'Poetsen One', category: 'Schmuckschrift & Display', fallback: 'sans-serif' },
      { family: 'Rakkas', label: 'Rakkas', category: 'Schmuckschrift & Display', fallback: 'serif' },
      { family: 'Six Caps', label: 'Six Caps', category: 'Schmuckschrift & Display', fallback: 'sans-serif' },
      { family: 'Stardos Stencil', label: 'Stardos Stencil', category: 'Schmuckschrift & Display', fallback: 'serif' },
      { family: 'Tulpen One', label: 'Tulpen One', category: 'Schmuckschrift & Display', fallback: 'serif' },
      { family: 'Vampiro One', label: 'Vampiro One', category: 'Schmuckschrift & Display', fallback: 'serif' },
      { family: 'Averia Libre', label: 'Averia Libre', category: 'Sonderformen', fallback: 'serif' },
      { family: 'Manufacturing Consent', label: 'Manufacturing Consent', category: 'Sonderformen', fallback: 'sans-serif' },
      { family: 'Noto Serif Tangut', label: 'Noto Serif Tangut', category: 'Sonderformen', fallback: 'serif' },
      { family: 'Playwrite IN', label: 'Playwrite IN', category: 'Sonderformen', fallback: 'cursive' },
      { family: 'WDXL Lubrifont TC', label: 'WDXL Lubrifont TC', category: 'Sonderformen', fallback: 'sans-serif' },
    ],
  };

  var state = {
    mode: 'text',
    file: null,
    imageDataUrl: '',
    logoMaskDataUrl: '',
    logoIsVector: false,
    text: '',
    font: configuration.defaultFont,
    textScale: 100,
    textLineSpacing: 100,
    exactTextKey: '',
    exactTextResult: null,
    zoom: 100,
    panX: 0,
    panY: 0,
    rightsAccepted: false,
    correctionProof: 'Bitte Korrekturabzug senden',
    imageWidth: 0,
    imageHeight: 0,
    fileType: '',
    rasterQuality: '',
    uploadStatus: { message: '', kind: '' },
    qualityFeedback: { message: '', kind: '' },
    renderSequence: 0,
    fileReadSequence: 0,
    fileReady: false,
    drag: null,
  };
  var fontLoadRequests = {};
  var textEngineRequest = null;
  var motivNudgeScheduled = false;
  var cartPreparation = null;
  var preparedCart = null;
  var splitCartUncertain = false;
  var roninControls = null;
  var roninDesign = {product:'RONIN',mode:'motif',motifId:'bergstadt-logo',scale:85,font:'Galada'};
  var roninChoiceKey = '';
  var roninDrafts = {};
  var roninVirtualChoiceKey = new URLSearchParams(window.location.search).get('gravur_motiv') || '';
  var roninSplitOptIn = new URLSearchParams(window.location.search).get('gravur_split_cart') === '1';
  function isRoninSplitCart() {
    return isRonin() && (configuration.customerOrderingEnabled || (configuration.splitCartPreviewEnabled && roninSplitOptIn));
  }
  function isRonin() { return configuration.product === 'RONIN'; }
  var roninReviewOptIn = new URLSearchParams(window.location.search).get('gravur_review_order') === '1';
  function isRoninReviewOrder() {
    return isRonin() && configuration.reviewOrderEnabled &&
      roninReviewOptIn;
  }
  if (isRonin()) { state.mode = 'motif'; state.textScale = 85; }

  function q(selector, root) {
    return (root || document).querySelector(selector);
  }

  function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  function currentValue(optionName) {
    if (optionName === 'Motiv' && isRoninSplitCart()) {
      var choices = window.__gravurRoninCatalog?.shopChoices || [];
      var chosen = choices.find(function (item) { return item.key === roninVirtualChoiceKey; });
      if (chosen) return chosen.label;
    }
    var checked = q('input[type="radio"][name^="' + optionName + '-"]:checked');
    if (!checked) checked = q('select[name="options[' + optionName + ']"]');
    if (optionName === 'Motiv' && isRoninSplitCart() && checked?.value === 'Thermo-Bierkrug') return 'Ohne Gravur';
    return checked ? checked.value : null;
  }

  function isCustomMotivSelected() {
    return isRonin() ? currentValue('Motiv') !== 'Ohne Gravur' : currentValue('Motiv') === configuration.customMotivValue;
  }

  function roninChoice() {
    var choices = window.__gravurRoninCatalog && window.__gravurRoninCatalog.shopChoices;
    return choices && choices.find(function (choice) { return choice.label === currentValue('Motiv'); });
  }

  function decorateRoninMotivPicker() {
    if (!isRonin()) return;
    if (isRoninSplitCart()) { decorateRoninSharedPicker(); return; }
    var list=q('.gravur-native-motifs');
    var catalog=window.__gravurRoninCatalog;
    if (!list || !catalog?.shopChoices) return;
    list.querySelectorAll('input[type="radio"]').forEach(function (input) {
      var label=list.querySelector('label[for="'+input.id+'"]');
      var choice=catalog.shopChoices.find(function (item) { return item.label===input.value; });
      if (!label || !choice || label.dataset.gravurDecorated) return;
      label.dataset.gravurDecorated='true';
      var motif=choice.design?.mode==='motif' && catalog.motifs.find(function (item) { return item.id===choice.design.motifId; });
      if (motif) {
        var image=document.createElement('img');image.src=motif.data;image.alt='';image.width=image.height=72;
        label.prepend(image);
      }
      if (choice.personalized) {
        var badge=document.createElement('small');badge.textContent='+5 \u20ac';label.append(badge);
      }
      if (input.disabled || input.classList.contains('disabled')) {
        var availability=document.createElement('small');
        availability.className='gravur-native-availability';
        availability.textContent='Ausverkauft';
        // Dawn already includes the availability message in the radio label.
        availability.setAttribute('aria-hidden','true');
        label.append(availability);
      }
    });
  }

  function decorateRoninSharedPicker() {
    var native = q('variant-selects .gravur-native-motif-fieldset');
    var selector = native && native.closest('variant-selects');
    var catalog = window.__gravurRoninCatalog;
    if (!selector || !catalog?.shopChoices) return;
    if (!roninVirtualChoiceKey) roninVirtualChoiceKey = (roninChoice() || catalog.shopChoices[0]).key;
    native.hidden = true;
    var list = q('[data-gravur-shared-choices]');
    if (!list) {
      var field = document.createElement('fieldset'); field.className = 'gravur-shared-motif-fieldset';
      var legend = document.createElement('legend'); legend.textContent = 'Motiv'; field.append(legend);
      var navigation = document.createElement('div'); navigation.className = 'gravur-mobile-motif-nav';
      var selected = document.createElement('span'); selected.dataset.gravurSelectedMotif = ''; navigation.append(selected);
      var arrows = document.createElement('div'); navigation.append(arrows);
      [-1,1].forEach(function(direction) {
        var arrow = document.createElement('button'); arrow.type = 'button';
        arrow.textContent = direction < 0 ? '\u2190' : '\u2192';
        arrow.setAttribute('aria-label',direction < 0 ? 'Vorherige Motive anzeigen' : 'Weitere Motive anzeigen');
        arrow.addEventListener('click',function() {
          list.scrollBy({left:direction * Math.max(120,list.clientWidth * .8),behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
        });
        arrows.append(arrow);
      });
      field.append(navigation);
      list = document.createElement('div'); list.className = 'gravur-shared-motifs motiv-swatch-row';
      list.dataset.gravurSharedChoices = ''; field.append(list);
      catalog.shopChoices.forEach(function (choice) {
        var button = document.createElement('button'); button.type = 'button';
        button.className = 'gravur-shared-motif-card'; button.dataset.gravurSharedChoice = choice.key;
        var motif = choice.design?.mode === 'motif' && catalog.motifs.find(function (item) { return item.id === choice.design.motifId; });
        if (motif) {var image = document.createElement('img');image.src=motif.data;image.alt='';image.width=image.height=72;button.append(image);}
        if (choice.design?.mode === 'template') {
          var nameHint = document.createElement('span');nameHint.className = 'gravur-shared-name-hint';
          nameHint.textContent = 'Name';button.append(nameHint);
        }
        var text = document.createElement('span');text.textContent = choice.label;button.append(text);
        if (choice.personalized) {var badge=document.createElement('small');badge.textContent='+5 \u20ac';button.append(badge);}
        button.addEventListener('click',function (event) {
          event.preventDefault();event.stopPropagation();roninVirtualChoiceKey = choice.key;
          var url = new URL(window.location.href);url.searchParams.set('gravur_motiv',choice.key);
          window.history.replaceState({},'',url);sync();
        });
        list.append(button);
      });
      var note=document.createElement('p');note.dataset.gravurSharedPrice='';field.append(note);
      selector.after(field);
    }
    var selectedMotif = q('[data-gravur-selected-motif]');
    if (selectedMotif) selectedMotif.textContent = roninChoice()?.label || '';
    list.querySelectorAll('[data-gravur-shared-choice]').forEach(function (button) {
      button.setAttribute('aria-pressed',String(button.dataset.gravurSharedChoice===roninVirtualChoiceKey));
    });
    var price=q('[data-gravur-shared-price]');
    if(price)price.textContent=roninChoice()?.personalized ? 'Gesamt 30 \u20ac: Krug 25 \u20ac + individuelle Gravur 5 \u20ac.' : 'Krug inklusive gewaehltem Grundmotiv: 25 \u20ac.';
    var url = new URL(window.location.href);
    if (url.searchParams.get('gravur_motiv') !== roninVirtualChoiceKey || (!configuration.customerOrderingEnabled && url.searchParams.get('gravur_split_cart') !== '1')) {
      url.searchParams.set('gravur_motiv',roninVirtualChoiceKey);
      if (!configuration.customerOrderingEnabled) url.searchParams.set('gravur_split_cart','1');
      window.history.replaceState({},'',url);
    }
    // Dawn binds the actual color to the original raw variant and its inventory.
    var raw=native.querySelector('input[value="Thermo-Bierkrug"]') || native.querySelector('input[value="Ohne Gravur"]');
    if(raw && !raw.checked)raw.click();
  }

  function syncRoninChoice() {
    if (!isRonin()) return;
    var choice = roninChoice();
    if (!choice || choice.key === roninChoiceKey) return;
    var previous = {
      design: Object.assign({},roninDesign), mode:state.mode,text:state.text,font:state.font,
      scale:state.textScale,spacing:state.textLineSpacing
    };
    if (roninChoiceKey) roninDrafts[roninChoiceKey] = previous;
    roninChoiceKey = choice.key;
    var saved = choice.personalized && (roninDrafts[choice.key] ||
      (previous.design.mode === 'template' && choice.design?.mode === 'template' && previous));
    roninDesign = Object.assign({product:'RONIN',font:'Galada'},choice.design || {},saved && saved.design);
    if (choice.design?.mode === 'template') Object.assign(roninDesign,{
      templateSymbol:choice.design.templateSymbol,beerIcon:choice.design.beerIcon,beerIconRatio:choice.design.beerIconRatio
    });
    state.mode = choice.key === 'eigenes-motiv' ? (saved && saved.mode === 'upload' ? 'upload' : 'text') : (choice.design || {}).mode || 'motif';
    state.text = saved ? saved.text : '';
    state.font = saved ? saved.font : 'Galada';
    state.textScale = saved ? saved.scale : (choice.design || {}).scale || 100;
    state.textLineSpacing = saved ? saved.spacing : 100;
    state.exactTextKey = '';
    state.exactTextResult = null;
    preparedCart = null;
    if (roninControls) roninControls.load(Object.assign({},roninDesign,{mode:state.mode,scale:state.textScale}));
  }

  function roninContractMessage(panel) {
    if (!isRonin()) return '';
    var choice = roninChoice();
    var form = q('form[id="' + getFormId(panel) + '"]');
    var input = form && q('input[name="id"]',form);
    var info = form && form.closest('product-info');
    var data = info && q('variant-selects [data-selected-variant]',info);
    try {
      var selected = JSON.parse(data && data.textContent);
      var nativeVariant = configuration.variants.find(function (variant) { return input && String(variant.id) === input.value; });
      if (!choice || !selected || !nativeVariant || String(selected.id) !== input.value ||
          selected.price !== (isRoninSplitCart() ? 2500 : choice.priceCents) || nativeVariant.price !== (isRoninSplitCart() ? 2500 : choice.priceCents) ||
          !selected.options || !nativeVariant.options ||
          selected.options[0] !== currentValue('Farbe') || (isRoninSplitCart() ? !['Ohne Gravur','Thermo-Bierkrug'].includes(selected.options[1]) : selected.options[1] !== choice.label) ||
          nativeVariant.options[0] !== currentValue('Farbe') || (isRoninSplitCart() ? !['Ohne Gravur','Thermo-Bierkrug'].includes(nativeVariant.options[1]) : nativeVariant.options[1] !== choice.label) ||
          selected.options[1] !== nativeVariant.options[1])
        return 'Motiv und Kaufvariante sind noch nicht synchron. Bitte auf die aktualisierte Auswahl warten. Individuelle Gravur kostet 30 Euro.';
      if (isRoninSplitCart() && (!window.__gravurSplitCart ||
          !window.__gravurSplitCart.baseIds.includes(input.value) || (choice.personalized && !configuration.splitCartFeeAvailable)))
        return 'Die individuelle Gravur ist gerade nicht verfuegbar. Bitte versuche es spaeter erneut oder kontaktiere uns.';
      if (roninChoiceKey !== choice.key ||
          (choice.design?.mode === 'motif' && (state.mode !== 'motif' || roninDesign.motifId !== choice.design.motifId || state.textScale !== choice.design.scale)) ||
          (choice.design?.mode === 'template' && (state.mode !== 'template' || roninDesign.templateSymbol !== choice.design.templateSymbol)) ||
          (choice.key === 'eigenes-motiv' && !['text','upload'].includes(state.mode)))
        return 'Deine Gestaltung passt nicht zur gewaehlten Motivvariante. Bitte das Motiv erneut auswaehlen.';
      return '';
    } catch (_) {
      return 'Kaufvariante konnte noch nicht geprueft werden. Bitte die Seite neu laden.';
    }
  }

  function getPanel() {
    return q('#trini-custom-panel');
  }

  function getFormId(panel) {
    var fieldWithForm = panel.querySelector('[form]');
    var productForm = q('product-form form[id]');
    // Dawn's hidden variant input is named "id", so form.id can resolve to that
    // input instead of the form's id. Reading the literal attribute avoids losing
    // every line-item property during add-to-cart.
    return (fieldWithForm && fieldWithForm.getAttribute('form')) || (productForm && productForm.getAttribute('id')) || '';
  }

  function ensureFormAssociation(panel) {
    var formId = getFormId(panel);
    if (!formId) return;

    panel.querySelectorAll('[name^="properties["]').forEach(function (input) {
      input.setAttribute('form', formId);
    });
  }

  function selectedVariantAvailable(panel) {
    var form = q('form[id="' + getFormId(panel) + '"]');
    var info = form && form.closest('product-info');
    var data = info && q('variant-selects [data-selected-variant]', info);
    var input = form && q('input[name="id"]', form);
    try {
      var variant = JSON.parse(data && data.textContent);
      return Boolean(input && variant && String(variant.id) === input.value && variant.available === true);
    } catch (_) {
      return false;
    }
  }

  function enforceVariantAvailability(panel) {
    var form = q('form[id="' + getFormId(panel) + '"]');
    var button = form && q('[type="submit"]', form);
    var blocked = isCustomMotivSelected() && ((isRonin() && (!(isRoninReviewOrder() || isRoninSplitCart()) || roninContractMessage(panel))) || !selectedVariantAvailable(panel));
    if (button && (blocked || (isRoninSplitCart() && splitCartUncertain)) && !button.disabled) {
      if (isRoninSplitCart()) button.dataset.gravurBlocked = 'true';
      button.disabled = true;
    } else if (button && isRoninSplitCart() && !blocked && !splitCartUncertain && button.dataset.gravurBlocked === 'true') {
      delete button.dataset.gravurBlocked;button.disabled = false;
    }
  }

  function bindPurchaseGuard(panel) {
    var form = q('form[id="' + getFormId(panel) + '"]');
    var button = form && q('[type="submit"]', form);
    if (!button || button.dataset.gravurAvailabilityBound || typeof MutationObserver !== 'function') return;
    button.dataset.gravurAvailabilityBound = 'true';
    // Other app scripts must not enable an unavailable personalized variant.
    var observer = new MutationObserver(function () {
      if (!button.isConnected) { observer.disconnect(); return; }
      enforceVariantAvailability(getPanel() || panel);
    });
    observer.observe(button, { attributes: true, attributeFilter: ['disabled'] });
  }

  function createGravurId() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
      return 'gravur-' + window.crypto.randomUUID();
    }
    return 'gravur-' + Date.now() + '-' + Math.random().toString(36).slice(2, 10);
  }

  function fontDetails(family) {
    return configuration.fonts.find(function (font) {
      return font.family === family;
    }) || configuration.fonts.find(function (font) {
      return font.family === configuration.defaultFont;
    });
  }

  function fontStack(family) {
    var font = fontDetails(family);
    return "'Gravur " + font.family + "', " + font.fallback;
  }

  function fontPickerOptionsMarkup() {
    var groups = {};
    configuration.fonts.forEach(function (font) {
      (groups[font.category] || (groups[font.category] = [])).push(font);
    });
    return Object.keys(groups).map(function (category) {
      return '<div class="trini-studio__font-group"><p class="trini-studio__font-group-title">' + category + '</p>' + groups[category].map(function (font) {
        return (
          '<button class="trini-studio__font-option" type="button" role="option" aria-selected="false" ' +
          'data-gravur-font-option="' + font.family + '" style="font-family:' + fontStack(font.family) + '">' +
          '<span class="trini-studio__font-name">' + font.label + '</span>' +
          '<span class="trini-studio__font-preview" aria-hidden="true">Glück auf</span>' +
          '</button>'
        );
      }).join('') + '</div>';
    }).join('');
  }

  function ensureStudioFont(family) {
    if (fontLoadRequests[family]) return fontLoadRequests[family];
    var asset = configuration.fontAssets[family];
    if (!asset || !asset.url || !window.FontFace || !document.fonts) return Promise.resolve(false);
    var request = new Promise(function (resolve) {
      var face = new window.FontFace('Gravur ' + family, 'url(' + JSON.stringify(asset.url) + ') format("woff2")', { weight: '400', style: 'normal', display: 'swap' });
      var settled = false;
      var timeout = window.setTimeout(function () { finish(false); }, 15000);
      function finish(loaded) {
        if (settled) return;
        settled = true;
        window.clearTimeout(timeout);
        if (loaded) document.fonts.add(face);
        resolve(loaded);
      }
      face.load().then(function () { finish(face.status === 'loaded'); }, function () { finish(false); });
    }).then(function (loaded) {
      // A transient failure must not poison this family for the rest of the visit.
      if (!loaded && fontLoadRequests[family] === request) delete fontLoadRequests[family];
      return loaded;
    });
    fontLoadRequests[family] = request;
    return request;
  }

  function applyStudioFont(panel) {
    var requested = state.font;
    if (panel.dataset.gravurFontRequested === requested) return;
    panel.dataset.gravurFontRequested = requested;
    delete panel.dataset.gravurFontApplied;
    var retry = q('[data-gravur-font-retry]', panel);
    if (retry) retry.hidden = true;

    ensureStudioFont(requested).then(function (loaded) {
      if (panel.dataset.gravurFontRequested !== requested || state.font !== requested || !panel.isConnected) return;
      if (!loaded) {
        panel.dataset.gravurFontError = 'true';
        setQuality(panel, 'Diese Schrift konnte nicht geladen werden. Bitte versuche es erneut oder wähle eine andere Schrift.', 'care');
        if (retry) retry.hidden = false;
        return;
      }
      if (panel.dataset.gravurFontError) {
        delete panel.dataset.gravurFontError;
        setQuality(panel, '', '');
      }

      var stack = fontStack(requested);
      var text = q('[data-gravur-text]', panel);
      var fontInput = q('[data-gravur-font]', panel);
      var fontTrigger = q('[data-gravur-font-toggle]', panel);
      var fontCurrent = q('[data-gravur-font-current]', panel);
      var sample = q('[data-gravur-font-sample]', panel);
      if (text) {
        text.style.fontFamily = stack;
        text.classList.toggle('is-visible', !configuration.textEngineUrl && Boolean(text.textContent.trim()));
        if (!configuration.textEngineUrl) fitTextToSurface(panel);
      }
      if (fontInput) fontInput.style.fontFamily = stack;
      if (fontTrigger) fontTrigger.style.fontFamily = stack;
      if (fontCurrent) fontCurrent.style.fontFamily = stack;
      if (sample) sample.style.fontFamily = stack;
      panel.dataset.gravurFontApplied = requested;
    });
  }

  function ensureTextEngine() {
    if (window.__gravurTextEngine) return Promise.resolve(window.__gravurTextEngine);
    if (textEngineRequest) return textEngineRequest;
    textEngineRequest = new Promise(function (resolve, reject) {
      var script = document.createElement('script');
      var timer = window.setTimeout(function () { reject(new Error('Die Textvorschau konnte nicht geladen werden.')); }, 20000);
      script.src = configuration.textEngineUrl;
      script.onload = function () {
        window.clearTimeout(timer);
        if (window.__gravurTextEngine) resolve(window.__gravurTextEngine);
        else reject(new Error('Die Textvorschau ist noch nicht bereit.'));
      };
      script.onerror = function () { window.clearTimeout(timer); reject(new Error('Die Textvorschau konnte nicht geladen werden.')); };
      document.head.appendChild(script);
    }).catch(function (error) { textEngineRequest = null; throw error; });
    return textEngineRequest;
  }

  function exactTextKey() {
    if (isRonin()) return JSON.stringify([roninDesign,state.mode,state.text,state.font,state.textScale,state.textLineSpacing,currentValue('Farbe'),currentValue('Motiv'),
      state.mode === 'upload' ? [state.logoMaskDataUrl,state.file && state.file.name,state.imageWidth,state.imageHeight,state.zoom,state.panX,state.panY,state.rightsAccepted,state.rasterQuality] : null]);
    return JSON.stringify([state.text, state.font, state.textScale, state.textLineSpacing, configuration.physicalArea]);
  }

  function emojiTextMessage(text) {
    return /[\p{Extended_Pictographic}\p{Regional_Indicator}\p{Emoji_Modifier}\uFE0F\u20E3]/u.test(text)
      ? 'Emojis sind als Gravurtext nicht geeignet. Bitte entfernen und ein Symbol stattdessen als Grafik verwenden.' : '';
  }

  function renderExactText(panel) {
    var preview = q('[data-gravur-text-paths]', panel);
    if (!preview) return;
    var active = isRonin() ? (state.mode === 'upload' ? hasImagePreview() && Boolean(state.logoMaskDataUrl) : state.mode !== 'text' || Boolean(state.text.trim())) : state.mode === 'text' && Boolean(state.text.trim());
    var key = exactTextKey();
    var ready = active && state.exactTextKey === key && Boolean(state.exactTextResult);
    var status = q('[data-gravur-text-status]', panel);
    if (status) status.hidden = !active || ready || (state.exactTextKey === key && panel.dataset.gravurTextError === 'true');
    preview.classList.toggle('is-visible', ready);
    if(isRonin() && window.__gravurTextEngine)window.__gravurTextEngine.updateMaskShine(preview,ready ? state.exactTextResult.photoBounds || state.exactTextResult.bounds : null,ready ? state.exactTextResult.photoViewport || state.exactTextResult.viewport : {width:60,height:60},ready);
    if (!active) return;
    var emojiMessage = !isRonin() || state.mode === 'text' ? emojiTextMessage(state.text) : '';
    if (emojiMessage) {
      state.exactTextKey = key;
      state.exactTextResult = null;
      panel.dataset.gravurTextError = 'true';
      preview.classList.remove('is-visible');
      if (status) status.hidden = true;
      var emojiRetry = q('[data-gravur-font-retry]', panel);
      if (emojiRetry) emojiRetry.hidden = true;
      setQuality(panel, emojiMessage, 'care');
      return;
    }
    if (ready) {
      if (isRonin()) {
        // The photomask pads the physical viewport to preserve its proportions.
        preview.style.setProperty('mask-size', '100% 100%');
        preview.style.setProperty('-webkit-mask-size', '100% 100%');
        preview.style.setProperty('mask-position', 'center');
        preview.style.setProperty('-webkit-mask-position', 'center');
      }
      preview.style.setProperty('--gravur-logo-mask', 'url("data:image/svg+xml,' + encodeURIComponent(state.exactTextResult.photoSvg || state.exactTextResult.svg) + '")');
      preview.setAttribute('aria-label', state.text);
      return;
    }
    if (state.exactTextKey === key) return;
    state.exactTextKey = key;
    state.exactTextResult = null;
    var input = { asset: configuration.fontAssets[state.font], family: state.font, text: state.text,
      physical: configuration.physicalArea, scale: state.textScale, spacing: state.textLineSpacing };
    ensureTextEngine().then(function (engine) {
      if (isRonin() && state.mode === 'upload') return engine.renderUpload({
        version:'gravur-studio/v8',product:'RONIN',mode:'upload',profileVersion:'ronin-physical/v2',
        calibrationId:window.__gravurRoninCatalog.profile.calibrationId,physicalArea:configuration.physicalArea,
        previewOnly:true,productionEnabled:false,sourceFile:state.file.name,sourceType:state.fileType,
        sourceWidth:state.imageWidth,sourceHeight:state.imageHeight,zoom:state.zoom,panX:state.panX,panY:state.panY,
        color:currentValue('Farbe'),rightsConfirmed:state.rightsAccepted,rasterQuality:state.rasterQuality
      },state.logoMaskDataUrl);
      return isRonin() ? engine.renderProductDesign({design:Object.assign({},roninDesign,{product:'RONIN',mode:state.mode,text:state.text,font:state.font,scale:state.textScale,lineSpacing:state.textLineSpacing,color:currentValue('Farbe')}),catalog:window.__gravurRoninCatalog,fontAssets:configuration.fontAssets}) : engine.render(input);
    }).then(function (result) {
      if (state.exactTextKey !== key || exactTextKey() !== key) return;
      if (isRonin() && (result.config?.profileVersion !== 'ronin-physical/v2' ||
          result.config?.calibrationId !== window.__gravurRoninCatalog?.profile?.calibrationId ||
          result.viewport?.width !== 60 || result.viewport?.height !== 60 || result.config?.productionEnabled !== false)) {
        throw new Error('RONIN-Vorschau ist veraltet oder unvollstaendig. Bitte die Seite neu laden.');
      }
      state.exactTextResult = result;
      var current = getPanel();
      if (current && (state.mode === 'text' || isRonin())) {
        if (current.dataset.gravurTextError) { delete current.dataset.gravurTextError; setQuality(current, '', ''); }
        clearSubmissionFeedback(current);
        var retry = q('[data-gravur-font-retry]', current);
        if (retry && !current.dataset.gravurFontError) retry.hidden = true;
        renderExactText(current);
        updateCropProperties(current);
      }
    }).catch(function (error) {
      if (state.exactTextKey !== key || exactTextKey() !== key) return;
      if (state.mode !== 'text' && !isRonin()) { state.exactTextKey = ''; return; }
      var current = getPanel();
      if (current) {
        current.dataset.gravurTextError = 'true';
        var status = q('[data-gravur-text-status]', current);
        if (status) status.hidden = true;
        setQuality(current, error.message + (error.code === 'EMOJI_NOT_SUPPORTED' ? '' : ' Bitte erneut laden oder eine andere Schrift wählen.'), 'care');
        var retry = q('[data-gravur-font-retry]', current);
        if (retry) retry.hidden = error.code === 'EMOJI_NOT_SUPPORTED';
      }
    });
  }

  function helpMarkup(id, label, text) {
    return `<details class="trini-studio__help" data-gravur-help>
      <summary aria-label="Info: ${label}" aria-controls="${id}"><span aria-hidden="true">i</span></summary>
      <p class="trini-studio__help-content" id="${id}">${text}</p>
    </details>`;
  }

  function closeHelp(panel, target, restoreFocus) {
    panel.querySelectorAll('[data-gravur-help][open]').forEach(function (help) {
      if (target && help.contains(target)) return;
      help.open = false;
      if (restoreFocus && help.contains(document.activeElement)) help.querySelector('summary').focus();
    });
  }

  function panelTemplate(formId) {
    return `
      <div class="trini-studio__intro">
        <p class="trini-studio__eyebrow">Dein eigenes Motiv</p>
        <h2 class="trini-studio__title">Gravur-Studio</h2>
        <p class="trini-studio__lead">Gestalte deine Dose direkt auf der Gravurfläche. Die Vorschau zeigt Form, Farbe und Ausschnitt zur Orientierung.</p>
      </div>

      <p class="trini-studio__unavailable is-hidden" data-gravur-unavailable role="status">Für diese Farbe fehlt noch die passende Deckelvorschau. Eigenes Motiv ist deshalb noch nicht online bestellbar. <a href="/pages/wunschprodukt">Frag deine Gravur hier an.</a></p>
        <div class="trini-studio__mode-row" aria-label="Art der Personalisierung">
          <button class="trini-studio__mode is-selected" type="button" data-gravur-mode="text">
            <svg class="trini-studio__mode-icon" viewBox="0 0 64 64" fill="currentColor" aria-hidden="true"><path d="m48 3.25h-32a12.76 12.76 0 0 0 -12.75 12.75v32a12.76 12.76 0 0 0 12.75 12.75h32a12.76 12.76 0 0 0 12.75-12.75v-32a12.76 12.76 0 0 0 -12.75-12.75zm6.75 17.54a.76.76 0 0 1 -.75.75h-4a.76.76 0 0 1 -.75-.75v-3.85h-14.5v30.12h5.84a.76.76 0 0 1 .75.75v4a.76.76 0 0 1 -.75.75h-17.18a.76.76 0 0 1 -.75-.75v-4a.76.76 0 0 1 .75-.75h5.84v-30.12h-14.5v3.85a.76.76 0 0 1 -.75.75h-4a.76.76 0 0 1 -.75-.75v-8.6a.76.76 0 0 1 .75-.75h44a.76.76 0 0 1 .75.75z"/></svg>
            <span>Text</span>
          </button>
          <button class="trini-studio__mode" type="button" data-gravur-mode="upload">
            <svg class="trini-studio__mode-icon" viewBox="0 0 512 512" fill="currentColor" aria-hidden="true"><path d="m477.282 28.039h-442.568c-19.179 0-34.714 14.593-34.714 32.619v390.679c0 18.022 15.535 32.624 34.714 32.624h442.568c19.18 0 34.718-14.6 34.718-32.624v-390.679c0-18.026-15.538-32.619-34.718-32.619zm-442.568 32.619h442.568v375.1h-442.568zm425.223 358.79h-407.867v-104.6a47.192 47.192 0 0 1 12.082-31.336l101.166-113.998c10.852-11.9 30.723-11.172 40.609 1.465l115.16 146.532 59.179-58.71a27.244 27.244 0 0 1 37.841 0l29.514 32.807a47.189 47.189 0 0 1 12.316 31.592zm-112.813-273.171c0-24.792 21.343-44.851 47.722-44.851s47.734 20.059 47.734 44.851-21.35 44.846-47.734 44.846-47.722-20.058-47.722-44.846z"/></svg>
            <span>Logo / Grafik</span>
          </button>
        </div>

      <div class="trini-studio__stage" data-gravur-stage>
        <div class="trini-studio__lid" data-gravur-lid>
          <div class="trini-studio__engraving" data-gravur-surface tabindex="0" aria-label="Ausschnitt auf der Gravurfläche verschieben">
            <span class="trini-studio__preview-logo" data-gravur-logo aria-label="Dein Logo in der Vorschau"></span>
            <span class="trini-studio__preview-logo" data-gravur-text-paths role="img" aria-label="Dein Text in der Vorschau"></span>
            <p class="trini-studio__preview-text" data-gravur-text></p>
            <p class="trini-studio__empty" data-gravur-empty>Wähle einen Text oder ein Logo für deine Gravur</p>
          </div>
        </div>
      </div>

      <div class="trini-studio__controls">
        <div class="trini-studio__field" data-gravur-upload>
          <div class="trini-studio__field-head">
            <label for="gravur-studio-file">Dein Logo oder deine Grafik</label>
            ${helpMarkup('gravur-studio-file-help', 'Logo / Grafik', 'PNG und SVG zeigen wir direkt. Am besten eignet sich ein SVG mit transparentem Hintergrund oder ein dunkles PNG-Logo. Bei JPG blendet die Vorschau helle Flächen bestmöglich aus. PDFs nehmen wir als Werkstattdatei an, zeigen sie aber nicht in der Vorschau.')}
          </div>
          <input id="gravur-studio-file" type="file" name="properties[_Logo-Datei]" accept="image/png,image/svg+xml,application/pdf,image/jpeg" form="${formId}" data-gravur-file>
          <p class="trini-studio__upload-status" data-gravur-upload-status role="status" hidden></p>
          <p class="trini-studio__upload-help"><strong>Nur ein JPG oder Probleme beim Upload?</strong> <a href="/pages/wunschprodukt">Zum Anfrageformular</a> – dort kannst du eine manuelle Prüfung oder Aufbereitung anfragen.</p>
        </div>

        <fieldset class="trini-studio__approval is-hidden" data-gravur-approval>
          <legend>Vor dem Lasern</legend>
          <p>Bei JPG und PDF empfehlen wir einen Korrekturabzug. Du entscheidest selbst, ob wir ihn vor der Gravur senden sollen.</p>
          <label>
            <input type="radio" name="properties[Korrekturabzug]" value="Bitte Korrekturabzug senden" form="${formId}" data-gravur-approval-option checked>
            <span>Bitte Korrekturabzug senden</span>
          </label>
          <label>
            <input type="radio" name="properties[Korrekturabzug]" value="Kein Korrekturabzug – nach meiner Datei gravieren" form="${formId}" data-gravur-approval-option>
            <span>Kein Korrekturabzug – bitte nach meiner Datei gravieren</span>
          </label>
        </fieldset>

        <div class="trini-studio__field is-hidden" data-gravur-text-field>
          <div class="trini-studio__field-head">
            <label for="gravur-studio-text">Dein Wunschtext</label>
            ${helpMarkup('gravur-studio-text-help', 'Wunschtext', 'Bis zu 120 Zeichen inklusive Leerzeichen und Umbrüchen. Mit Enter oder Shift + Enter setzt du eine neue Zeile. Deine eigenen Zeilen bleiben erhalten; die Schrift passt sich an die Gravurfläche an.')}
          </div>
          <textarea id="gravur-studio-text" name="properties[Wunschtext]" rows="4" maxlength="120" placeholder="z. B. Glück auf&#10;Opa" aria-describedby="gravur-studio-text-count" form="${formId}" data-gravur-text-input></textarea>
          <p class="trini-studio__character-count" id="gravur-studio-text-count" data-gravur-text-count>0 / 120 Zeichen</p>
        </div>

        <div class="trini-studio__field is-hidden" data-gravur-font-field>
          <span class="trini-studio__field-label">Schriftart</span>
          <div class="trini-studio__font-picker" data-gravur-font-picker>
            <button class="trini-studio__font-trigger" type="button" aria-expanded="false" aria-controls="gravur-studio-font-options" data-gravur-font-toggle>
              <span data-gravur-font-current>${configuration.defaultFont}</span>
              <svg class="trini-studio__font-chevron" viewBox="0 0 16 10" fill="none" aria-hidden="true"><path d="m1 1 7 7 7-7" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/></svg>
            </button>
            <div class="trini-studio__font-options" id="gravur-studio-font-options" role="listbox" hidden data-gravur-font-options>
              ${fontPickerOptionsMarkup()}
            </div>
          </div>
          <input id="gravur-studio-font" type="hidden" name="properties[Schriftart]" value="${configuration.defaultFont}" form="${formId}" data-gravur-font>
          <p class="trini-studio__font-sample" data-gravur-font-sample>Schriftprobe: Glück auf</p>
          <button type="button" class="button button--secondary" data-gravur-font-retry hidden>Schrift erneut laden</button>
        </div>

        <div class="trini-studio__range trini-studio__field is-hidden" data-gravur-text-scale-field>
          <div class="trini-studio__range-head">
            <div class="trini-studio__label-group">
              <label class="trini-studio__range-label" for="gravur-studio-text-scale">Textgröße</label>
              ${helpMarkup('gravur-studio-size-help', 'Textgröße', '100 % nutzt die maximal passende Textgröße. Du kannst den Text kleiner stellen; er bleibt immer innerhalb der Gravurfläche.')}
            </div>
            <output for="gravur-studio-text-scale" data-gravur-text-scale-output>100 %</output>
          </div>
          <input id="gravur-studio-text-scale" type="range" min="60" max="100" step="1" value="100" data-gravur-text-scale>
        </div>

        <div class="trini-studio__range trini-studio__field is-hidden" data-gravur-line-spacing-field>
          <div class="trini-studio__range-head">
            <div class="trini-studio__label-group">
              <label class="trini-studio__range-label" for="gravur-studio-line-spacing">Zeilenabstand</label>
              ${helpMarkup('gravur-studio-spacing-help', 'Zeilenabstand', 'Wirkt bei mehrzeiligem Text. Bei 0 % liegen die Buchstaben fast aneinander, ohne sich zu überlappen. Bei mehr Abstand wird die Schrift bei Bedarf kleiner, damit sie in die Gravurfläche passt.')}
            </div>
            <output for="gravur-studio-line-spacing" data-gravur-line-spacing-output>100 %</output>
          </div>
          <input id="gravur-studio-line-spacing" type="range" min="0" max="160" step="1" value="100" data-gravur-line-spacing>
        </div>

        <div class="trini-studio__field" data-gravur-image-controls>
          <div class="trini-studio__range">
            <div class="trini-studio__range-head">
              <label class="trini-studio__range-label" for="gravur-studio-zoom">Ausschnitt</label>
              <output for="gravur-studio-zoom" data-gravur-zoom-output>100 %</output>
            </div>
            <input id="gravur-studio-zoom" type="range" min="80" max="180" step="1" value="100" data-gravur-zoom>
          </div>

        </div>

        <p class="trini-studio__quality" data-gravur-text-status role="status" hidden>Textvorschau wird vorbereitet …</p>
        <p class="trini-studio__quality" data-gravur-quality aria-live="polite"></p>
        <p class="trini-studio__quality" data-gravur-cart-status role="status" hidden></p>
        <input type="file" name="properties[Motivvorschau]" form="${formId}" data-gravur-cart-file hidden disabled>

        <div class="trini-studio__rights" data-gravur-rights>
          <input id="gravur-studio-rights" type="checkbox" name="properties[_Rechte-Bestaetigung]" value="Ja" form="${formId}" data-gravur-rights-input>
          <label for="gravur-studio-rights">Ich bestätige, dass ich die Rechte an der hochgeladenen Datei besitze.</label>
        </div>

        <input type="hidden" name="properties[_Personalisierung]" value="Eigenes Motiv" form="${formId}" data-gravur-property="personalization">
        <input type="hidden" name="properties[_Ausschnitt]" form="${formId}" data-gravur-property="crop">
        <input type="hidden" name="properties[_Gravurgröße]" form="${formId}" data-gravur-property="text-scale">
        <input type="hidden" name="properties[_Zeilenabstand]" form="${formId}" data-gravur-property="line-spacing">
        <input type="hidden" name="properties[Gestaltung]" value="Deine Gestaltung ist gespeichert. Das Produktbild zeigt die Dose ohne Gravur." form="${formId}" data-gravur-property="customer-note">
        <input type="hidden" name="properties[Logo-Dateiname]" form="${formId}" data-gravur-property="file-name">
        <input type="hidden" name="properties[_gravur_studio]" form="${formId}" data-gravur-property="config">
        <input type="hidden" name="properties[_gravur_id]" form="${formId}" data-gravur-property="id" value="${createGravurId()}">
        <div class="trini-studio__notice trini-studio__field-head">
          <span>Vorschau zur Orientierung.</span>
          ${helpMarkup('gravur-studio-material-help', 'Material und Vorschau', 'Die Gravur legt das gebürstete Edelstahl frei. Die Vorschau zeigt Form und Ausschnitt, ist aber keine verbindliche Farb- oder Materialprobe.')}
        </div>
      </div>
    `;
  }

  function ensureHomeMarker(panel) {
    var marker = q('[data-gravur-studio-home]');
    if (marker || !panel.parentNode) return marker;

    marker = document.createElement('span');
    marker.hidden = true;
    marker.dataset.gravurStudioHome = '';
    panel.parentNode.insertBefore(marker, panel);
    return marker;
  }

  function hydratePanel(panel) {
    if (!panel) return;

    if (panel.dataset.gravurStudioHydrated !== 'true') {
      var formId = getFormId(panel);
      panel.classList.add('trini-studio');
      panel.dataset.gravurStudioHydrated = 'true';
      panel.innerHTML = panelTemplate(formId);
      if (isRonin()) {
        panel.dataset.gravurProduct = 'RONIN';
        q('.trini-studio__lead',panel).textContent = isRoninSplitCart() ? 'Gestalte deinen RONIN. Individuelle Gravur +5 Euro. Deine Gestaltung wird zusammen mit dem Krug gespeichert.' : isRoninReviewOrder() ? 'RONIN-Testbestellung: ausschliesslich zur Pruefung der Auftragsablage. NICHT PRODUZIEREN.' : 'Gestalte deinen RONIN mit einem Motiv oder deinem Text. Vorschau in Vorbereitung, noch nicht bestellbar.';
        q('[data-gravur-mode="upload"]',panel).hidden = false;
        q('label[for="gravur-studio-text-scale"]',panel).textContent='Motivgröße';
        q('[data-gravur-text-paths]',panel).setAttribute('aria-label','Dein Motiv in der Vorschau');
        q('[data-gravur-surface]',panel).setAttribute('aria-label','Manuell eingemessener RONIN-Gravurbereich, 60 mal 60 Millimeter');
        var root = document.createElement('div');root.dataset.gravurMotifControls='';
        q('.trini-studio__controls',panel).prepend(root);
        q('[data-gravur-text-scale]',panel).min='25';
        ensureTextEngine().then(function(engine){
          if (!panel.isConnected) return;
          roninControls=engine.motifControls(root,window.__gravurRoninCatalog,function(value){
            var choice=roninChoice();
            if (!choice || choice.design?.mode !== 'template') return;
            roninDesign=Object.assign({},value,{templateSymbol:choice.design.templateSymbol,
              beerIcon:choice.design.beerIcon,beerIconRatio:choice.design.beerIconRatio});
            state.mode='template';state.textScale=value.scale;refreshPanel(panel);
          },document,{nativeMotiv:true});
          syncRoninChoice();
          roninControls.load(Object.assign({},roninDesign,{mode:state.mode,scale:state.textScale}));
          refreshPanel(panel);
        }).catch(function(error){setQuality(panel,error.message,'care');});
      }
      ensureHomeMarker(panel);
      bindSurface(panel);
    }
    ensureFormAssociation(panel);
    bindPurchaseGuard(panel);
  }

  function restorePanelHome() {
    var panel = getPanel();
    var marker = q('[data-gravur-studio-home]');
    if (!panel || !marker || !marker.parentNode) return;

    if (panel.parentNode !== marker.parentNode || panel.previousElementSibling !== marker) {
      marker.parentNode.insertBefore(panel, marker.nextSibling);
    }

    var mediaWrapper = q('.product__media-wrapper.trini-studio-active');
    if (mediaWrapper) mediaWrapper.classList.remove('trini-studio-active');
  }

  function movePanelToGallery(panel) {
    var mediaWrapper = q('product-info .product__media-wrapper');
    if (!mediaWrapper) return;

    mediaWrapper.classList.add('trini-studio-active');
    var productInfo = mediaWrapper.closest('product-info');
    var choices = q('.gravur-shared-motif-fieldset');
    var mobile = isRoninSplitCart() && window.matchMedia('(max-width: 749px)').matches && choices;
    if (productInfo) productInfo.classList.toggle('gravur-ronin-mobile',Boolean(mobile));
    if (mobile) {
      if (panel.previousElementSibling !== choices) choices.after(panel);
      return;
    }
    if (panel.parentNode !== mediaWrapper) mediaWrapper.appendChild(panel);
  }

  function setDisabled(element, disabled) {
    if (element) element.disabled = disabled;
  }

  function setHidden(element, hidden) {
    if (element) element.classList.toggle('is-hidden', hidden);
  }

  function updateMaterialColor(panel) {
    var color = currentValue('Farbe');
    panel.dataset.gravurColor = color || '';
    var unavailable = !configuration.lidImages[color];
    setHidden(q('[data-gravur-stage]', panel), unavailable);
    setHidden(q('[data-gravur-unavailable]', panel), !unavailable);
    var lid = q('[data-gravur-lid]', panel);
    if (!lid) return;
    lid.style.setProperty('--gravur-lid-color', configuration.colorValues[color] || '#a8a69f');
    lid.style.setProperty('--gravur-lid-image', configuration.lidImages[color] ? 'url("' + configuration.lidImages[color] + '")' : 'none');
    lid.style.setProperty('--gravur-metal-texture', configuration.metalTexture ? 'url("' + configuration.metalTexture + '")' : 'none');
    if(isRonin() && window.__gravurRoninCatalog){
      var area=window.__gravurRoninCatalog.profile.photoArea,surface=q('[data-gravur-surface]',panel);
      surface.style.left=area.centerX*100+'%';surface.style.top=area.centerY*100+'%';
      surface.style.width=area.width*100+'%';surface.style.height=area.height*100+'%';surface.style.borderRadius='0';
      var layer=q('[data-gravur-text-paths]',panel);
      layer.style.backgroundSize=(100/area.width)+'% '+(100/area.height)+'%';
      layer.style.backgroundPosition=((area.centerX-area.width/2)/(1-area.width)*100)+'% '+((area.centerY-area.height/2)/(1-area.height)*100)+'%';
    }
  }

  function updateCropProperties(panel) {
    var hasCrop = hasImagePreview();
    var crop = q('[data-gravur-property="crop"]', panel);
    var textScale = q('[data-gravur-property="text-scale"]', panel);
    var lineSpacing = q('[data-gravur-property="line-spacing"]', panel);
    var fileName = q('[data-gravur-property="file-name"]', panel);
    var personalization = q('[data-gravur-property="personalization"]', panel);
    var config = q('[data-gravur-property="config"]', panel);
    if (isRonin()) {
      if (config) config.value = state.exactTextResult && state.exactTextKey === exactTextKey() ? JSON.stringify(state.exactTextResult.config) : '';
      var note=q('[data-gravur-property="customer-note"]',panel);
      if(note)note.value=isRoninSplitCart() ? 'Deine Gestaltung ist gespeichert. Das Produktbild im Checkout zeigt den Krug ohne Gravur.' : isRoninReviewOrder() ? 'RONIN-Testbestellung. Keine Produktionsfreigabe. NICHT PRODUZIEREN.' : 'RONIN-Vorschau in Vorbereitung. Noch nicht zur Bestellung freigegeben.';
      if(personalization)personalization.value=state.mode==='motif' ? roninDesign.motifId : state.mode==='template' ? 'Feierabendkrug' : 'Eigenes Motiv';
      if(fileName)fileName.value=state.mode==='upload' && state.file ? state.file.name : '';
      return;
    }
    if (crop) crop.value = hasCrop ? 'Zoom ' + state.zoom + '% · X ' + state.panX + '% · Y ' + state.panY + '%' : '';
    if (textScale) textScale.value = state.mode === 'text' ? String(state.textScale) + '%' : '';
    if (lineSpacing) lineSpacing.value = state.mode === 'text' ? String(state.textLineSpacing) + '%' : '';
    if (fileName) fileName.value = state.mode === 'upload' && state.file ? state.file.name : '';
    if (personalization) personalization.value = 'Eigenes Motiv';
    if (config) {
      var exact = state.mode === 'text' && state.exactTextKey === exactTextKey() && state.exactTextResult;
      config.value = JSON.stringify({
        version: exact ? 'gravur-studio/v6' : 'gravur-studio/v5',
        designId: q('[data-gravur-property="id"]', panel).value,
        area: { centerXPercent: 50.3, centerYPercent: 47.1, widthPercent: 46, heightPercent: 46, borderRadiusPercent: 21.5 },
        referenceImage: configuration.lidImages[currentValue('Farbe')] || null,
        textLayout: exact ? exact.config.textLayout : (state.mode === 'text' ? captureTextLayout(panel) : null),
        fontAsset: exact ? exact.config.fontAsset : null,
        physicalArea: configuration.physicalArea,
        mode: state.mode,
        text: exact ? exact.config.text : (state.mode === 'text' ? state.text : ''),
        font: state.mode === 'text' ? state.font : null,
        textPosition: state.mode === 'text' ? 'center' : null,
        textScale: state.mode === 'text' ? state.textScale : null,
        textLineSpacing: state.mode === 'text' ? state.textLineSpacing : null,
        correctionProof: state.mode === 'upload' ? state.correctionProof : null,
        zoom: hasCrop ? state.zoom : null,
        panX: hasCrop ? state.panX : null,
        panY: hasCrop ? state.panY : null,
        color: currentValue('Farbe'),
        motiv: currentValue('Motiv'),
        rightsConfirmed: state.mode === 'upload' ? state.rightsAccepted : null,
        sourceFile: state.mode === 'upload' && state.file ? state.file.name : null,
        sourceType: state.mode === 'upload' ? state.fileType : null,
        sourceWidth: state.mode === 'upload' ? state.imageWidth || null : null,
        sourceHeight: state.mode === 'upload' ? state.imageHeight || null : null,
        rasterQuality: state.mode === 'upload' ? state.rasterQuality || null : null,
      });
    }
  }

  function captureTextLayout(panel) {
    var text = q('[data-gravur-text]', panel);
    var surface = q('[data-gravur-surface]', panel);
    if (!text || !text.firstChild || !surface || !surface.clientWidth || panel.dataset.gravurFontApplied !== state.font) return null;
    var box = surface.getBoundingClientRect();
    var style = window.getComputedStyle(text);
    var lines = [];
    function percent(value, total) { return Math.round(value / total * 100000) / 1000; }
    // Store actual browser line breaks, not a new guess made later at a different viewport width.
    for (var index = 0; index < text.firstChild.length; index += 1) {
      var character = text.firstChild.textContent[index];
      if (character === '\n' || character === '\r') continue;
      var range = document.createRange();
      range.setStart(text.firstChild, index);
      range.setEnd(text.firstChild, index + 1);
      var rect = range.getBoundingClientRect();
      var line = lines[lines.length - 1];
      if (!line || Math.abs(line.top - rect.top) > 1) {
        line = { text: '', top: rect.top, left: rect.left, right: rect.right, height: rect.height };
        lines.push(line);
      }
      line.text += character;
      line.left = Math.min(line.left, rect.left);
      line.right = Math.max(line.right, rect.right);
    }
    return {
      units: 'percent-of-engraving-area',
      fontSize: percent(parseFloat(style.fontSize), box.width),
      fontWeight: style.fontWeight,
      lineHeight: percent(parseFloat(style.lineHeight), box.height),
      lines: lines.map(function (line) {
        return { text: line.text, x: percent(line.left - box.left, box.width), y: percent(line.top - box.top, box.height), width: percent(line.right - line.left, box.width), height: percent(line.height, box.height) };
      }),
    };
  }

  function setFontPickerOpen(panel, open) {
    var toggle = q('[data-gravur-font-toggle]', panel);
    var options = q('[data-gravur-font-options]', panel);
    if (!toggle || !options || (open && toggle.disabled)) return;
    options.hidden = !open;
    if (open && panel.dataset.gravurFontPickerLoaded !== 'true') {
      // Only visible rows need their font. Do not download the entire 42-font library.
      panel.dataset.gravurFontPickerLoaded = 'true';
      var rows = panel.querySelectorAll('[data-gravur-font-option]');
      if (window.IntersectionObserver) {
        var observer = new window.IntersectionObserver(function (entries) {
          if (!panel.isConnected) { observer.disconnect(); return; }
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              ensureStudioFont(entry.target.dataset.gravurFontOption).then(function (loaded) {
                if (loaded) observer.unobserve(entry.target);
              });
            }
          });
        }, { root: options, rootMargin: '80px' });
        rows.forEach(function (option) { observer.observe(option); });
      } else {
        rows.forEach(function (option) { ensureStudioFont(option.dataset.gravurFontOption); });
      }
    }
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function updateFontPicker(panel) {
    var font = fontDetails(state.font);
    var current = q('[data-gravur-font-current]', panel);
    if (current) current.textContent = font.label;
    panel.querySelectorAll('[data-gravur-font-option]').forEach(function (option) {
      var selected = option.dataset.gravurFontOption === state.font;
      option.classList.toggle('is-selected', selected);
      option.setAttribute('aria-selected', selected ? 'true' : 'false');
    });
  }

  function updateInputs(panel) {
    var uploadMode = state.mode === 'upload';
    var hasCrop = hasImagePreview();
    var active = isCustomMotivSelected();
    var fileInput = q('[data-gravur-file]', panel);
    var textInput = q('[data-gravur-text-input]', panel);
    var fontSelect = q('[data-gravur-font]', panel);
    var rights = q('[data-gravur-rights-input]', panel);
    var zoom = q('[data-gravur-zoom]', panel);
    var textScale = q('[data-gravur-text-scale]', panel);
    var lineSpacing = q('[data-gravur-line-spacing]', panel);
    var approval = q('[data-gravur-approval]', panel);
    var fontToggle = q('[data-gravur-font-toggle]', panel);
    var personalization = q('[data-gravur-property="personalization"]', panel);
    var crop = q('[data-gravur-property="crop"]', panel);
    var textScaleProperty = q('[data-gravur-property="text-scale"]', panel);
    var lineSpacingProperty = q('[data-gravur-property="line-spacing"]', panel);
    var fileNameProperty = q('[data-gravur-property="file-name"]', panel);
    var config = q('[data-gravur-property="config"]', panel);

    setHidden(q('[data-gravur-upload]', panel), !uploadMode);
    setHidden(q('[data-gravur-text-field]', panel), uploadMode);
    setHidden(q('[data-gravur-font-field]', panel), uploadMode);
    setHidden(q('[data-gravur-text-scale-field]', panel), uploadMode);
    setHidden(q('[data-gravur-line-spacing-field]', panel), uploadMode);
    setHidden(q('[data-gravur-image-controls]', panel), !hasCrop);
    setHidden(q('[data-gravur-rights]', panel), !uploadMode);
    setHidden(approval, !uploadMode || !state.file);

    setDisabled(fileInput, !active || !uploadMode);
    setDisabled(textInput, !active || uploadMode);
    setDisabled(fontSelect, !active || uploadMode);
    setDisabled(fontToggle, !active || uploadMode);
    panel.querySelectorAll('[data-gravur-font-option]').forEach(function (option) {
      setDisabled(option, !active || uploadMode);
    });
    setDisabled(rights, !active || !uploadMode);
    setDisabled(zoom, !active || !hasCrop);
    setDisabled(textScale, !active || uploadMode);
    setDisabled(lineSpacing, !active || uploadMode);
    panel.querySelectorAll('[data-gravur-approval-option]').forEach(function (option) {
      option.disabled = !active || !uploadMode || !state.file;
      option.checked = option.value === state.correctionProof;
    });
    setDisabled(personalization, !active);
    setDisabled(q('[data-gravur-property="customer-note"]', panel), !active);
    setDisabled(crop, !active || !hasCrop);
    setDisabled(textScaleProperty, !active || uploadMode);
    setDisabled(lineSpacingProperty, !active || uploadMode);
    setDisabled(fileNameProperty, !active || !uploadMode);
    setDisabled(config, !active);
    setDisabled(q('[data-gravur-property="id"]', panel), !active);
    if (!active) clearCartMockup(panel);

    if (fileInput) fileInput.required = active && uploadMode;
    if (textInput) textInput.required = active && !uploadMode;
    if (rights) rights.required = active && uploadMode;

    panel.querySelectorAll('[data-gravur-mode]').forEach(function (button) {
      var selected = button.dataset.gravurMode === state.mode;
      button.classList.toggle('is-selected', selected);
      button.setAttribute('aria-pressed', selected ? 'true' : 'false');
    });

    if (textInput) textInput.value = state.text;
    var textCount = q('[data-gravur-text-count]', panel);
    if (textCount) textCount.textContent = state.text.length + ' / 120 Zeichen';
    if (fontSelect) fontSelect.value = state.font;
    updateFontPicker(panel);
    if (uploadMode) setFontPickerOpen(panel, false);
    if (rights) rights.checked = state.rightsAccepted;
    if (zoom) zoom.value = String(state.zoom);
    if (textScale) textScale.value = String(state.textScale);
    if (lineSpacing) lineSpacing.value = String(state.textLineSpacing);

    var zoomOutput = q('[data-gravur-zoom-output]', panel);
    var textScaleOutput = q('[data-gravur-text-scale-output]', panel);
    if (zoomOutput) zoomOutput.textContent = state.zoom + ' %';
    if (textScaleOutput) textScaleOutput.textContent = state.textScale + ' %';
    var lineSpacingOutput = q('[data-gravur-line-spacing-output]', panel);
    if (lineSpacingOutput) lineSpacingOutput.textContent = state.textLineSpacing + ' %';

    if (isRonin()) {
      setHidden(q('[data-gravur-text-field]',panel),state.mode!=='text');
      setHidden(q('[data-gravur-font-field]',panel),!['text','template'].includes(state.mode));
      setHidden(q('[data-gravur-line-spacing-field]',panel),!['text','template'].includes(state.mode));
      setHidden(q('.trini-studio__mode-row',panel),roninChoice()?.key !== 'eigenes-motiv');
      setHidden(q('[data-gravur-text-scale-field]',panel),!['text','template'].includes(state.mode));
      if(textInput){textInput.required=active && state.mode==='text';textInput.disabled=!active || state.mode!=='text';}
      // Fixed motifs are real product variants, not editable personalization drafts.
      var choice=roninChoice();
      if (!active || !choice || (!choice.personalized && !isRoninSplitCart())) {
        panel.querySelectorAll('[name^="properties["]').forEach(function (input) { input.disabled=true; });
        clearCartMockup(panel);
      }
      if(roninControls && state.mode !== 'upload')roninControls.setMode(state.mode,false);
    }
    updateCropProperties(panel);
  }

  function applyTransform(panel) {
    if (isRonin() && state.mode === 'upload') { renderExactText(panel); return; }
    var logo = q('[data-gravur-logo]', panel);
    var surface = q('[data-gravur-surface]', panel);
    if (!logo || !surface || !state.imageWidth || !state.imageHeight) return;

    // Do not scale the logo element itself: that would scale and shift the brushed
    // steel texture as well. The mask alone receives the customer's crop settings.
    var baseScale = Math.min(surface.clientWidth / state.imageWidth, surface.clientHeight / state.imageHeight);
    var width = state.imageWidth * baseScale * state.zoom / 100;
    var height = state.imageHeight * baseScale * state.zoom / 100;
    var left = (surface.clientWidth - width) / 2 + state.panX / 100 * surface.clientWidth;
    var top = (surface.clientHeight - height) / 2 + state.panY / 100 * surface.clientHeight;
    logo.style.setProperty('--gravur-logo-mask-size', width + 'px ' + height + 'px');
    logo.style.setProperty('--gravur-logo-mask-position', left + 'px ' + top + 'px');
  }

  function fitTextToSurface(panel) {
    var text = q('[data-gravur-text]', panel);
    var surface = q('[data-gravur-surface]', panel);
    if (!text || !surface || !text.textContent.trim()) return;

    // Start at a deliberately generous size. The fit loop below still keeps every text inside the laser area.
    var maxSize = Math.max(18, Math.floor(Math.min(surface.clientWidth * 0.72, surface.clientHeight * 0.64)));
    var minSize = 1;
    // scrollWidth/scrollHeight are integers. A fractional limit can stay smaller
    // than the rounded scrollWidth even when the text fits, forcing the minimum.
    var availableWidth = Math.floor(surface.clientWidth * 0.86);
    var availableHeight = Math.floor(surface.clientHeight * 0.84);
    var size = maxSize;

    text.style.width = availableWidth + 'px';
    // Explicit customer lines must shrink to fit, not acquire extra automatic breaks.
    text.style.whiteSpace = /[\r\n]/.test(text.textContent) ? 'pre' : 'pre-wrap';
    text.style.lineHeight = String(1.13 * state.textLineSpacing / 100);
    text.style.fontSize = size + 'px';
    while (size > minSize && (text.scrollWidth > availableWidth || text.scrollHeight > availableHeight)) {
      size -= 1;
      text.style.fontSize = size + 'px';
    }
    size = Math.max(minSize, Math.floor(size * state.textScale / 100));
    text.style.fontSize = size + 'px';
  }

  function hasImagePreview() {
    return state.mode === 'upload' && state.fileReady && Boolean(state.imageDataUrl);
  }

  function renderFeedback(panel) {
    var quality = q('[data-gravur-quality]', panel);
    if (quality) {
      quality.textContent = state.qualityFeedback.mode === state.mode ? state.qualityFeedback.message : '';
      quality.dataset.state = state.qualityFeedback.mode === state.mode ? state.qualityFeedback.kind : '';
    }
    var status = q('[data-gravur-upload-status]', panel);
    if (status) {
      status.textContent = state.uploadStatus.message;
      status.dataset.state = state.uploadStatus.kind;
      status.hidden = !state.uploadStatus.message;
    }
  }

  function setQuality(panel, message, kind, source) {
    state.qualityFeedback = { message: message || '', kind: kind || '', mode: state.mode, source: source || '' };
    renderFeedback(panel);
  }

  function clearSubmissionFeedback(panel) {
    if (state.qualityFeedback.source === 'submit') setQuality(panel, '', '');
  }

  function setUploadStatus(panel, message, kind) {
    state.uploadStatus = { message: message || '', kind: kind || '' };
    renderFeedback(panel);
  }

  function svgDimensions(dataUrl) {
    try {
      var comma = dataUrl.indexOf(',');
      var header = dataUrl.slice(0, comma);
      var source = header.indexOf(';base64') !== -1
        ? window.atob(dataUrl.slice(comma + 1))
        : decodeURIComponent(dataUrl.slice(comma + 1));
      var root = new DOMParser().parseFromString(source, 'image/svg+xml').documentElement;
      if (root.localName !== 'svg' || root.querySelector('parsererror')) return null;
      var viewBox = (root.getAttribute('viewBox') || '').trim().split(/[\s,]+/).map(Number);
      if (viewBox.length === 4 && viewBox[2] > 0 && viewBox[3] > 0) {
        return { width: viewBox[2], height: viewBox[3] };
      }
      var width = parseFloat(root.getAttribute('width'));
      var height = parseFloat(root.getAttribute('height'));
      if (width > 0 && height > 0) return { width: width, height: height };
    } catch (error) {
      return null;
    }
    return { width: 1000, height: 1000 };
  }

  function renderLogoMask(panel) {
    state.logoMaskDataUrl = '';
    var sequence = ++state.renderSequence;

    if (state.logoIsVector) {
      // Keep well-formed SVG artwork direct and vector-sharp. The alpha channel
      // defines the logo; no browser-dependent inversion wrapper is involved.
      state.logoMaskDataUrl = state.imageDataUrl;
      renderPreview(panel);
      return;
    }

    var source = new Image();

    source.onload = function () {
      if (sequence !== state.renderSequence) return;

      var maxSide = 900;
      var scale = Math.min(1, maxSide / Math.max(source.naturalWidth, source.naturalHeight));
      var width = Math.max(1, Math.round(source.naturalWidth * scale));
      var height = Math.max(1, Math.round(source.naturalHeight * scale));
      var canvas = document.createElement('canvas');
      var context = canvas.getContext('2d', { willReadFrequently: true });
      canvas.width = width;
      canvas.height = height;
      context.drawImage(source, 0, 0, width, height);

      var pixels = context.getImageData(0, 0, width, height);
      var maskInk = 0;
      for (var index = 0; index < pixels.data.length; index += 4) {
        var luminance = 0.2126 * pixels.data[index] + 0.7152 * pixels.data[index + 1] + 0.0722 * pixels.data[index + 2];
        var sourceAlpha = pixels.data[index + 3] / 255;
        var maskAlpha = 1 - luminance / 255;
        pixels.data[index] = 255;
        pixels.data[index + 1] = 255;
        pixels.data[index + 2] = 255;
        pixels.data[index + 3] = Math.round(sourceAlpha * maskAlpha * 255);
        maskInk += pixels.data[index + 3];
      }
      if (isRonin() && !maskInk) {
        state.fileReady = false;
        setUploadStatus(panel, 'Diese Grafik enthaelt kein sichtbares Gravurmotiv. Bitte eine dunkle Grafik auf hellem oder transparentem Hintergrund hochladen.', 'care');
        refreshPanel(panel);
        return;
      }
      context.putImageData(pixels, 0, 0);
      state.logoMaskDataUrl = canvas.toDataURL('image/png');
      renderPreview(panel);
    };

    source.onerror = function () {
      if (sequence !== state.renderSequence) return;
      if (isRonin()) {
        state.fileReady = false;
        setUploadStatus(panel, 'Die Grafikvorschau konnte nicht erstellt werden. Bitte die Datei erneut auswaehlen.', 'care');
        refreshPanel(panel);
        return;
      }
      state.logoMaskDataUrl = state.imageDataUrl;
      renderPreview(panel);
    };
    source.src = state.imageDataUrl;
  }

  function renderPreview(panel) {
    if (!panel) return;

    var logo = q('[data-gravur-logo]', panel);
    var text = q('[data-gravur-text]', panel);
    var empty = q('[data-gravur-empty]', panel);
    var uploadMode = state.mode === 'upload';
    var hasImage = uploadMode && Boolean(state.imageDataUrl);
    var hasText = !uploadMode && Boolean(state.text.trim());
    var hasLogoPreview = !isRonin() && hasImage && Boolean(state.logoMaskDataUrl);

    applyStudioFont(panel);

    if (logo) {
      logo.classList.toggle('is-visible', hasLogoPreview);
      if (hasLogoPreview) {
        logo.style.setProperty('--gravur-logo-mask', 'url("' + state.logoMaskDataUrl + '")');
      } else {
        logo.style.removeProperty('--gravur-logo-mask');
      }
    }

    if (text) {
      text.textContent = hasText ? state.text : '';
      text.dataset.gravurGlowText = hasText ? state.text : '';
      text.classList.toggle('is-visible', !configuration.textEngineUrl && hasText && Boolean(panel.dataset.gravurFontApplied));
      if (!configuration.textEngineUrl && hasText && panel.dataset.gravurFontApplied) fitTextToSurface(panel);
    }
    if (configuration.textEngineUrl) renderExactText(panel);

    if (empty) {
      empty.classList.toggle('is-hidden', hasImage || hasText);
      if(isRonin() && state.mode!=='text')empty.classList.add('is-hidden');
      empty.textContent = uploadMode && state.fileReady && state.fileType === 'pdf'
        ? 'PDF angehängt – keine Vorschau. Wir verwenden deine Originaldatei.'
        : 'Wähle einen Text oder ein Logo für deine Gravur';
    }
    applyTransform(panel);
  }

  function refreshPanel(panel) {
    hydratePanel(panel);
    decorateRoninMotivPicker();
    if (isRoninSplitCart() && panel.classList.contains('is-active')) movePanelToGallery(panel);
    updateMaterialColor(panel);
    updateInputs(panel);
    renderFeedback(panel);
    renderPreview(panel);
    updateCropProperties(panel);
    enforceVariantAvailability(panel);
  }

  function activate(panel) {
    panel.classList.add('is-active');
    movePanelToGallery(panel);
    refreshPanel(panel);
  }

  function deactivate(panel) {
    restorePanelHome();
    // The variant picker is replaced by Dawn's AJAX response. Remove the gallery
    // state independently of the old home marker so standard motifs always return.
    var mediaWrapper = q('.product__media-wrapper.trini-studio-active');
    if (mediaWrapper) mediaWrapper.classList.remove('trini-studio-active');
    panel.classList.remove('is-active');
    refreshPanel(panel);
  }

  function restoreFileInput(panel) {
    var fileInput = q('[data-gravur-file]', panel);
    if (!fileInput || !state.file || fileInput.files.length) return;

    try {
      var transfer = new DataTransfer();
      transfer.items.add(state.file);
      fileInput.files = transfer.files;
    } catch (error) {
      setQuality(panel, 'Deine Datei bitte nach dem Farbwechsel noch einmal auswählen.', 'care');
    }
  }

  function readLogoFile(file, panel) {
    var readSequence = ++state.fileReadSequence;
    ++state.renderSequence;
    state.fileReady = false;
    state.imageDataUrl = '';
    state.logoMaskDataUrl = '';
    state.logoIsVector = false;
    state.imageWidth = 0;
    state.imageHeight = 0;
    state.fileType = '';
    state.rasterQuality = '';
    setQuality(panel, '', '');
    setUploadStatus(panel, file ? 'Datei wird geprüft …' : '', '');

    if (!file) {
      setUploadStatus(panel, '', '');
      refreshPanel(panel);
      return;
    }

    var filename = file.name || 'Deine Datei';
    var isPdf = file.type === 'application/pdf' || /\.pdf$/i.test(filename);
    var isJpeg = file.type === 'image/jpeg' || /\.jpe?g$/i.test(filename);
    var isSvg = file.type === 'image/svg+xml' || /\.svg$/i.test(filename);
    var isPreviewFile = isJpeg || file.type === 'image/png' || isSvg || /\.png$/i.test(filename);

    if (isPdf) {
      if (isRonin()) {
        state.fileReady=false;
        setUploadStatus(panel,'Fuer die RONIN-Dateivorschau bitte SVG, PNG oder JPG verwenden. PDFs koennen wir ueber das Anfrageformular manuell aufbereiten.','care');
        refreshPanel(panel);
        return;
      }
      state.fileType = 'pdf';
      state.fileReady = true;
      setUploadStatus(panel, 'Datei angehängt: ' + filename + '. PDFs werden mit der Bestellung übergeben, können im Studio aber nicht als Gravurvorschau angezeigt werden.', 'care');
      setQuality(panel, '', '');
      refreshPanel(panel);
      return;
    }

    if (!isPreviewFile) {
      state.file = null;
      var fileInput = q('[data-gravur-file]', panel);
      if (fileInput) fileInput.value = '';
      setUploadStatus(panel, 'Dieses Dateiformat kann hier nicht als Gravurvorschau verarbeitet werden. Bitte nutze PNG, SVG, JPG oder PDF – oder sende uns dein Logo über das Anfrageformular.', 'care');
      setQuality(panel, '', '');
      refreshPanel(panel);
      return;
    }

    var reader = new FileReader();
    reader.onload = function (event) {
      if (readSequence !== state.fileReadSequence) return;
      state.imageDataUrl = event.target.result;

      if (isSvg) {
        if (isRonin()) {
          ensureTextEngine().then(function(engine){
            if (readSequence !== state.fileReadSequence) return;
            var raw=new TextDecoder().decode(Uint8Array.from(window.atob(state.imageDataUrl.split(',')[1]),function(c){return c.charCodeAt(0);}));
            var safe=engine.normalizeLogo(raw);
            state.imageWidth=safe.viewBox[2];state.imageHeight=safe.viewBox[3];
            state.imageDataUrl='data:image/svg+xml,'+encodeURIComponent(safe.svg);
            state.logoIsVector=true;state.fileType='svg';state.fileReady=true;state.rasterQuality='vector';
            setUploadStatus(panel,'SVG angehaengt: '+filename+'. Original und Ausschnitt werden mit der Bestellung gespeichert.','good');
            renderLogoMask(panel);refreshPanel(panel);
          }).catch(function(error){
            if (readSequence !== state.fileReadSequence) return;
            state.fileReady=false;state.imageDataUrl='';
            setUploadStatus(panel,error.message+' Bitte die SVG als reine Pfade exportieren oder PNG verwenden.','care');refreshPanel(panel);
          });
          return;
        }
        var dimensions = svgDimensions(state.imageDataUrl);
        if (!dimensions) {
          state.imageDataUrl = '';
          setUploadStatus(panel, 'Diese SVG-Datei ist nicht lesbar. Bitte exportiere sie erneut oder nutze unser Anfrageformular.', 'care');
          refreshPanel(panel);
          return;
        }
        state.imageWidth = dimensions.width;
        state.imageHeight = dimensions.height;
        state.logoIsVector = true;
        state.fileType = 'svg';
        state.fileReady = true;
        state.rasterQuality = 'vector';
        setQuality(panel, 'SVG angehängt: Die Vorschau bleibt beim Skalieren vektorscharf.', 'good');
        setUploadStatus(panel, 'Datei angehängt: ' + filename + '. Die Vorschau zeigt die Gravur mit freigelegter Metallfläche.', 'good');
        renderLogoMask(panel);
        refreshPanel(panel);
        return;
      }

      var image = new Image();
      image.onload = function () {
        if (readSequence !== state.fileReadSequence) return;
        state.fileReady = true;
        state.imageWidth = image.naturalWidth;
        state.imageHeight = image.naturalHeight;
        state.fileType = isJpeg ? 'jpg' : 'png';

        var smallestSide = Math.min(state.imageWidth, state.imageHeight);
        var resolution = state.imageWidth + ' × ' + state.imageHeight + ' px';
        var meetsMinimumResolution = smallestSide >= 1000;
        state.rasterQuality = meetsMinimumResolution ? 'sufficient' : 'low';
        setQuality(
          panel,
          meetsMinimumResolution
            ? 'Auflösung: ' + resolution + '. Die Vorschau zeigt die freigelegte Metallfläche. Vor dem Lasern prüfen wir dein Logo noch einmal.'
            : 'Achtung: ' + resolution + '. Für eine saubere Gravur sollte die kürzere Seite mindestens 1000 px haben. Bitte eine größere PNG-Datei oder idealerweise ein SVG verwenden; ein Korrekturabzug ist empfohlen.',
          meetsMinimumResolution ? 'good' : 'care'
        );
        setUploadStatus(
          panel,
          isJpeg
            ? 'JPG angehängt: ' + filename + ' (' + resolution + '). Die Vorschau blendet helle Flächen bestmöglich aus; deine Datei wird als Bestellanhang gespeichert. Shopify kann JPGs beim Download optimieren. Ein Korrekturabzug ist empfohlen.'
            : 'Datei angehängt: ' + filename + ' (' + resolution + '). Die Vorschau zeigt die Gravur mit freigelegter Metallfläche.',
          isJpeg || !meetsMinimumResolution ? 'care' : 'good'
        );
        renderLogoMask(panel);
        refreshPanel(panel);
      };
      image.onerror = function () {
        if (readSequence !== state.fileReadSequence) return;
        state.imageDataUrl = '';
        setUploadStatus(panel, 'Diese Bilddatei konnte nicht gelesen werden. Bitte wähle eine andere Datei oder nutze das Anfrageformular.', 'care');
        setQuality(panel, '', '');
        refreshPanel(panel);
      };
      image.src = state.imageDataUrl;
    };
    reader.onerror = function () {
      if (readSequence !== state.fileReadSequence) return;
      setUploadStatus(panel, 'Die Grafik konnte gerade nicht gelesen werden. Versuch es bitte noch einmal oder nutze das Anfrageformular.', 'care');
    };
    reader.readAsDataURL(file);
  }

  function setMode(mode) {
    if(isRonin() && (roninChoice()?.key !== 'eigenes-motiv' || !['text','upload'].includes(mode)))return;
    state.mode = mode;
    if(isRonin() && roninControls && mode !== 'upload'){roninControls.setMode(mode,false);state.textScale=roninControls.snapshot().scale;}
    sync();
  }

  function bindSurface(panel) {
    var surface = q('[data-gravur-surface]', panel);
    if (!surface || surface.dataset.gravurBound === 'true') return;
    surface.dataset.gravurBound = 'true';
    if (typeof ResizeObserver === 'function') {
      var observer = new ResizeObserver(function () {
        if (!surface.isConnected) { observer.disconnect(); return; }
        fitTextToSurface(panel);
        applyTransform(panel);
      });
      observer.observe(surface);
    }

    surface.addEventListener('pointerdown', function (event) {
      if (state.mode !== 'upload' || !state.imageDataUrl) return;
      state.drag = {
        x: event.clientX,
        y: event.clientY,
        panX: state.panX,
        panY: state.panY,
        surface: surface,
      };
      surface.classList.add('is-dragging');
      surface.setPointerCapture(event.pointerId);
      event.preventDefault();
    });

    surface.addEventListener('pointermove', function (event) {
      if (!state.drag) return;
      var bounds = state.drag.surface.getBoundingClientRect();
      state.panX = clamp(state.drag.panX + ((event.clientX - state.drag.x) / bounds.width) * 100, -35, 35);
      state.panY = clamp(state.drag.panY + ((event.clientY - state.drag.y) / bounds.height) * 100, -35, 35);
      var activePanel = getPanel();
      if (activePanel) {
        applyTransform(activePanel);
        updateCropProperties(activePanel);
      }
    });

    function endDrag() {
      if (!state.drag) return;
      state.drag.surface.classList.remove('is-dragging');
      state.drag = null;
    }

    surface.addEventListener('pointerup', endDrag);
    surface.addEventListener('pointercancel', endDrag);
  }

  function sync() {
    var panel = getPanel();
    if (!panel) return;

    hydratePanel(panel);
    syncRoninChoice();
    restoreFileInput(panel);
    if (isCustomMotivSelected()) activate(panel);
    else deactivate(panel);
    scheduleMotivNudge();
  }

  function scheduleSync() {
    window.requestAnimationFrame(function () {
      window.setTimeout(sync, 0);
    });
  }

  function clearCartMockup(panel) {
    var input = q('[data-gravur-cart-file]', panel);
    if (input) { input.value = ''; input.disabled = true; }
    preparedCart = null;
  }

  function cartSignature(panel, form) {
    updateCropProperties(panel);
    return JSON.stringify([q('[data-gravur-property="config"]', panel).value,
      form.querySelector('[name="id"]').value,
      (form.querySelector('[name="quantity"]') || {}).value || '1',
      state.file && [state.file.name, state.file.size, state.file.lastModified],
      state.logoMaskDataUrl, state.text, state.font, state.textScale, state.textLineSpacing,
      state.zoom, state.panX, state.panY, state.rightsAccepted, getFormId(panel)]);
  }

  function cartSnapshot(panel) {
    var surface = q('[data-gravur-surface]', panel), stage = q('[data-gravur-stage]', panel), lid = q('[data-gravur-lid]', panel);
    var exact = (state.mode === 'text' || isRonin()) && state.exactTextKey === exactTextKey() && state.exactTextResult;
    var mask = exact ? 'data:image/svg+xml,' + encodeURIComponent(exact.photoSvg || exact.svg) : state.logoMaskDataUrl;
    if (!mask || !surface.clientWidth || !surface.clientHeight) throw new Error('Deine Gravurvorschau ist noch nicht bereit.');
    var config = JSON.parse(q('[data-gravur-property="config"]', panel).value);
    if (isRonin()) {
      var area = window.__gravurRoninCatalog.profile.photoArea;
      return { photo: configuration.lidImages[currentValue('Farbe')], metal: configuration.metalTexture,
        mask: mask, area: {centerXPercent:area.centerX*100,centerYPercent:area.centerY*100,widthPercent:area.width*100,heightPercent:area.height*100,borderRadiusPercent:0},
        stageZoom: lid.getBoundingClientRect().width / stage.getBoundingClientRect().width,
        opacity: .95, textureWidthFactor: 1 / area.width,
        textureSource: {x:area.centerX-area.width/2,y:area.centerY-area.height/2,width:area.width,height:area.height},
        materialBrightness: currentValue('Farbe') === 'Weiß' ? 194 / 255 : 1,
        maskBox: {x:0,y:0,width:1,height:1} };
    }
    var aspect = exact ? config.physicalArea.widthMm / config.physicalArea.heightMm : state.imageWidth / state.imageHeight;
    var fit = Math.min(surface.clientWidth / aspect, surface.clientHeight);
    var width = aspect * fit / surface.clientWidth, height = fit / surface.clientHeight;
    if (!exact) { width *= state.zoom / 100; height *= state.zoom / 100; }
    var visual = window.getComputedStyle(q(exact ? '[data-gravur-text-paths]' : '[data-gravur-logo]', panel));
    return { photo: config.referenceImage, metal: configuration.metalTexture, mask: mask, area: config.area,
      stageZoom: lid.getBoundingClientRect().width / stage.getBoundingClientRect().width,
      opacity: Number(visual.opacity), textureWidthFactor: parseFloat(visual.backgroundSize) / 100,
      maskBox: { x: (1 - width) / 2 + (exact ? 0 : state.panX / 100), y: (1 - height) / 2 + (exact ? 0 : state.panY / 100), width: width, height: height } };
  }

  async function prepareCartMockup(panel, form, submitter) {
    clearCartMockup(panel);
    var status = q('[data-gravur-cart-status]', panel);
    status.hidden = false; status.textContent = 'Deine Warenkorb-Vorschau wird vorbereitet …';
    var job = { panel: panel, form: form };
    cartPreparation = job;
    try {
      var signature = cartSignature(panel, form);
      if (!window.__gravurCartMockup) throw new Error('Die Bildvorschau konnte nicht geladen werden. Bitte lade die Seite neu.');
      var blob = await window.__gravurCartMockup.render(cartSnapshot(panel));
      if (cartPreparation !== job || getPanel() !== panel || !isCustomMotivSelected() || signature !== cartSignature(panel, form)) throw new Error('Deine Gestaltung wurde inzwischen geändert. Bitte erneut in den Warenkorb legen.');
      var transfer = new DataTransfer();
      transfer.items.add(new File([blob], 'Gravur-Vorschau-' + q('[data-gravur-property="id"]', panel).value + '.png', { type: 'image/png' }));
      var input = q('[data-gravur-cart-file]', panel);
      input.files = transfer.files; input.disabled = false;
      if (!input.files.length || input.files[0].size !== blob.size) throw new Error('Das Vorschaubild konnte nicht angehängt werden.');
      preparedCart = { panel: panel, form: form, signature: signature };
      cartPreparation = null;
      status.hidden = true;
      if (isRoninSplitCart()) {
        var source = new FormData(form), id = q('[data-gravur-property="id"]',panel).value;
        var data = window.__gravurSplitCart.build(source,roninChoice(),id);
        var root = window.Shopify?.routes?.root || '/';
        splitCartUncertain = true;
        var response = await fetch(root + 'cart/add.js',{method:'POST',body:data});
        if (!response.ok) throw new Error('Der Warenkorb konnte nicht vollstaendig bestaetigt werden. Bitte zuerst den Warenkorb pruefen, nicht erneut hinzufuegen.');
        var checked = await fetch(root + 'cart.js',{cache:'no-store'});
        var result = checked.ok && window.__gravurSplitCart.inspect(await checked.json());
        if (!result?.valid || !result.pairs.has(id)) throw new Error('Bitte den Warenkorb pruefen: Krug und Gravurleistung konnten nicht gemeinsam bestaetigt werden.');
        window.location.assign(root + 'cart');
      } else form.requestSubmit(submitter || undefined);
      // Native validation or another listener may cancel the replay. Never reuse its attachment.
      clearCartMockup(panel);
    } catch (error) {
      clearCartMockup(panel);
      status.hidden = false; status.textContent = error.message || 'Die Warenkorb-Vorschau konnte nicht erstellt werden. Bitte versuche es erneut.';
      status.dataset.state = 'care';
    } finally {
      if (cartPreparation === job) cartPreparation = null;
      if (isRoninSplitCart()) enforceVariantAvailability(panel);
    }
  }

  function scheduleMotivNudge() {
    if (motivNudgeScheduled || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    motivNudgeScheduled = true;

    window.setTimeout(function () {
      var row = q('.motiv-swatch-row');
      if (!row || row.scrollWidth <= row.clientWidth + 8 || row.scrollLeft > 0) return;

      var start = row.scrollLeft;
      var distance = Math.min(44, row.scrollWidth - row.clientWidth);
      row.dataset.motivNudge = 'played';
      if (typeof row.scrollTo === 'function') row.scrollTo({ left: distance, behavior: 'smooth' });
      else row.scrollLeft = distance;

      window.setTimeout(function () {
        if (typeof row.scrollTo === 'function') row.scrollTo({ left: start, behavior: 'smooth' });
        else row.scrollLeft = start;
      }, 760);
    }, 520);
  }

  // Real Shopify option changes need the native AJAX refresh. Return the studio
  // to its original DOM position before that refresh destroys the old selector.
  document.addEventListener(
    'change',
    function (event) {
      if (event.target.matches('input[type="radio"][name^="Farbe-"], input[type="radio"][name^="Motiv-"]')) {
        restorePanelHome();
      }
    },
    true
  );

  document.addEventListener(
    'change',
    function (event) {
      var panel = getPanel();
      if (!panel || !panel.contains(event.target)) return;
      clearSubmissionFeedback(panel);

      if (event.target.matches('[data-gravur-file]')) {
        event.stopPropagation();
        state.file = event.target.files && event.target.files[0] ? event.target.files[0] : null;
        readLogoFile(state.file, panel);
      } else if (event.target.matches('[data-gravur-font]')) {
        event.stopPropagation();
        state.font = event.target.value;
        refreshPanel(panel);
      } else if (event.target.matches('[data-gravur-rights-input]')) {
        event.stopPropagation();
        state.rightsAccepted = event.target.checked;
        if (isRonin() && state.mode === 'upload') renderPreview(panel);
        updateCropProperties(panel);
      } else if (event.target.matches('[data-gravur-approval-option]')) {
        event.stopPropagation();
        state.correctionProof = event.target.value;
        updateCropProperties(panel);
      }
    },
    true
  );

  document.addEventListener(
    'input',
    function (event) {
      var panel = getPanel();
      if (!panel || !panel.contains(event.target)) return;
      clearSubmissionFeedback(panel);

      if (event.target.matches('[data-gravur-text-input]')) {
        event.stopPropagation();
        state.text = event.target.value;
        refreshPanel(panel);
      } else if (event.target.matches('[data-gravur-zoom]')) {
        event.stopPropagation();
        state.zoom = Number(event.target.value);
        applyTransform(panel);
        updateCropProperties(panel);
        q('[data-gravur-zoom-output]', panel).textContent = state.zoom + ' %';
      } else if (event.target.matches('[data-gravur-text-scale]')) {
        event.stopPropagation();
        state.textScale = Number(event.target.value);
        if(isRonin() && roninControls)roninControls.setScale(state.textScale);
        q('[data-gravur-text-scale-output]', panel).textContent = state.textScale + ' %';
        renderPreview(panel);
        updateCropProperties(panel);
      } else if (event.target.matches('[data-gravur-line-spacing]')) {
        event.stopPropagation();
        var spacing = Number(event.target.value);
        if (!Number.isFinite(spacing)) return;
        state.textLineSpacing = Math.max(0, Math.min(160, spacing));
        event.target.value = String(state.textLineSpacing);
        q('[data-gravur-line-spacing-output]', panel).textContent = state.textLineSpacing + ' %';
        renderPreview(panel);
        updateCropProperties(panel);
      }
    },
    true
  );

  // Each add-to-cart receives its own ID. Shopify only merges identical variants
  // with identical properties, so two separate designs remain separate positions.
  document.addEventListener(
    'submit',
    function (event) {
      var panel = getPanel();
      var form = event.target;
      if (!panel || !isCustomMotivSelected() || !form || !form.matches('form')) return;
      if (form.getAttribute('id') !== getFormId(panel)) return;

      ensureFormAssociation(panel);
      var message = '';
      var fileInput = q('[data-gravur-file]', panel);
      if (isRoninSplitCart() && splitCartUncertain) {
        message = 'Bitte zuerst den Warenkorb pruefen. Eine erneute Uebertragung koennte die Gestaltung doppelt hinzufuegen.';
      } else if (isRonin() && !(isRoninReviewOrder() || isRoninSplitCart())) {
        message = 'RONIN ist noch in Vorbereitung: Produktion noch nicht freigegeben. Keine Bestellung aus dieser Vorschau.';
      } else if (isRonin() && roninContractMessage(panel)) {
        message = roninContractMessage(panel);
      } else if (isRonin() && (!state.exactTextResult || state.exactTextKey !== exactTextKey() || state.exactTextResult.config.productionEnabled !== false)) {
        message = 'Bitte warte auf die vollstaendige RONIN-Pruefgestaltung. Keine Produktionsfreigabe.';
      } else if (!selectedVariantAvailable(panel)) {
        message = 'Diese Variante ist aktuell nicht verfügbar. Bitte wähle eine andere Farbe oder nutze unser Anfrageformular.';
      } else if (!configuration.lidImages[currentValue('Farbe')]) {
        message = 'Für diese Farbe ist die Gravurvorschau noch nicht eingerichtet. Bitte wähle eine andere Farbe oder nutze unser Anfrageformular.';
      } else if (state.mode === 'text' && emojiTextMessage(state.text)) {
        message = emojiTextMessage(state.text);
      } else if (state.mode === 'text' && (!state.text.trim() || panel.dataset.gravurFontApplied !== state.font)) {
        message = 'Bitte gib einen Text ein und warte, bis deine gewählte Schrift geladen ist.';
      } else if (state.mode === 'text' && configuration.textEngineUrl && (!state.exactTextResult || state.exactTextKey !== exactTextKey())) {
        message = 'Bitte warte, bis deine Textvorschau fertig ist. Bei einer Fehlermeldung die Schrift erneut laden oder wechseln.';
      } else if (state.mode === 'upload' && (!state.fileReady || !state.file || !fileInput || !fileInput.files[0] || fileInput.files[0].name !== state.file.name || fileInput.files[0].size !== state.file.size || fileInput.files[0].lastModified !== state.file.lastModified || !state.rightsAccepted)) {
        message = 'Bitte lade deine Datei vollständig hoch und bestätige die Nutzungsrechte. Nach einem Farbwechsel die Datei gegebenenfalls erneut auswählen.';
      }
      if (message) {
        event.preventDefault();
        event.stopImmediatePropagation();
        setQuality(panel, message, 'care', 'submit');
        q('[data-gravur-quality]', panel).scrollIntoView({ block: 'center', behavior: 'smooth' });
        return;
      }
      if (isRonin() && !isRoninSplitCart() && !roninChoice().personalized) return;
      if (preparedCart && preparedCart.panel === panel && preparedCart.form === form && preparedCart.signature === cartSignature(panel, form)) {
        preparedCart = null;
        return;
      }
      event.preventDefault();
      event.stopImmediatePropagation();
      if (cartPreparation) return;
      var gravurId = q('[data-gravur-property="id"]', panel);
      if (gravurId) gravurId.value = createGravurId();
      if (state.mode === 'text' && !isRonin()) fitTextToSurface(panel);
      updateCropProperties(panel);
      // PDF artwork has no visual mask; keep its explicit placeholder instead of inventing a preview.
      if (state.mode === 'upload' && state.fileType === 'pdf') {
        clearCartMockup(panel);
        preparedCart = { panel: panel, form: form, signature: cartSignature(panel, form) };
        form.requestSubmit(event.submitter || undefined);
        clearCartMockup(panel);
        return;
      }
      prepareCartMockup(panel, form, event.submitter);
    },
    true
  );

  document.addEventListener(
    'click',
    function (event) {
      var panel = getPanel();
      if (panel) closeHelp(panel, event.target, false);
      if (panel && !panel.contains(event.target)) setFontPickerOpen(panel, false);
      if (panel && panel.contains(event.target)) {
        if (event.target.closest('[data-gravur-font-retry]')) {
          event.preventDefault();
          event.stopPropagation();
          delete panel.dataset.gravurFontRequested;
          state.exactTextKey = '';
          applyStudioFont(panel);
          renderPreview(panel);
          return;
        }
        var fontOption = event.target.closest('[data-gravur-font-option]');
        var fontToggle = event.target.closest('[data-gravur-font-toggle]');
        if (fontOption) {
          event.preventDefault();
          event.stopPropagation();
          clearSubmissionFeedback(panel);
          state.font = fontOption.dataset.gravurFontOption;
          setFontPickerOpen(panel, false);
          refreshPanel(panel);
          return;
        }
        if (fontToggle) {
          event.preventDefault();
          event.stopPropagation();
          setFontPickerOpen(panel, fontToggle.getAttribute('aria-expanded') !== 'true');
          return;
        }
        if (!event.target.closest('[data-gravur-font-picker]')) setFontPickerOpen(panel, false);
      }

      var button = event.target.closest('[data-gravur-mode]');
      if (!button) return;
      event.preventDefault();
      event.stopPropagation();
      setMode(button.dataset.gravurMode);
    },
    true
  );

  document.addEventListener(
    'keydown',
    function (event) {
      if (event.key !== 'Escape') return;
      var panel = getPanel();
      if (!panel) return;
      closeHelp(panel, null, true);
      var toggle = q('[data-gravur-font-toggle]', panel);
      if (toggle && toggle.getAttribute('aria-expanded') === 'true') {
        setFontPickerOpen(panel, false);
        toggle.focus();
      }
    },
    true
  );

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
    subscribe(PUB_SUB_EVENTS.variantChange, scheduleSync);
  }
  document.addEventListener('product-info:loaded', scheduleSync);
  if (typeof window.matchMedia === 'function') {
    window.matchMedia('(max-width: 749px)').addEventListener?.('change',scheduleSync);
  }

  window.__gravurStudio = { sync: sync };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync, { once: true });
  } else {
    sync();
  }
})();
